<template>
    <div ref="triggerElement" @mouseenter="show" @mouseleave="hide" class="new-popover ms-2 mb-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>
            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .879-.252 1.02-.598l.088-.416c.065-.293.132-.352.426-.421l.45-.083.082-.381-1.11-.14zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
        </svg>
    </div>

    <Popover
        :referenceElement="triggerElement"
        v-model:visible="visible"
        placement="top"
        :offset="[0, 8]"
    >
        <div class="popover-message" v-html="message"/>
    </Popover>
</template>

<script setup>
const Popover = defineAsyncComponent(() => import('~/components/Popover.vue'))

const props = defineProps({
    message: {
        type: String,
        required: true,
    },
});

const visible = ref(false);
const triggerElement = ref(null);

const show = () => {
    visible.value = true;
};

const hide = () => {
    visible.value = false;
};
</script>

<style scoped>

</style>
